import styles from "./Form.module.css";

function FormWrapper({ children, id, onSubmit, title, titleCenter, centerContent, className }) {
  return (
    <form
      id={id}
      onSubmit={onSubmit}
      className={`${styles.form} ${centerContent && styles.center} ${styles[className]}`}
    >
      {title && <div className={`${styles.title} ${titleCenter && "text-center"}`}>{title}</div>}
      {children}
    </form>
  );
}

export default FormWrapper;
